// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".menu-accion[data-v-489bb978] {\n  vertical-align: middle;\n  width: 250px !important;\n}\n.icono[data-v-489bb978],\n.accion[data-v-489bb978] {\n  vertical-align: top;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n[dir=ltr] .menu-accion .icono[data-v-489bb978] {\n  margin-right: 5px;\n}\n[dir=rtl] .menu-accion .icono[data-v-489bb978] {\n  margin-left: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
